import mod from "-!./Config.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Config.js?vue&type=script&lang=js&"